import React from 'react';
import PropTypes from 'prop-types';

const ShowMoreButton = ({
  showMoreHandler,
  hasNextPage,
  isLoading,
  remainingItems,
  text,
}) => (
  <div className="text-center">
    {hasNextPage && (
    <button
      onClick={showMoreHandler}
      className="button secondary pl-l pr-l pt-s pb-s border-quicksilver-100"
      style={{
        borderRadius: 0,
        border: '1px solid',
        backgroundColor: 'white',
      }}
      type="button"
    >
      {isLoading
        ? <div className="loading-spinner-m" style={{ marginLeft: '-20px' }} />
        : `${text}${remainingItems > 0 ? ` (${remainingItems})` : ''}`}
    </button>
    )}
  </div>
);

ShowMoreButton.propTypes = {
  showMoreHandler: PropTypes.func,
  hasNextPage: PropTypes.bool,
  isLoading: PropTypes.bool,
  remainingItems: PropTypes.number,
  text: PropTypes.string,
};

ShowMoreButton.defaultProps = {
  showMoreHandler: () => {},
  hasNextPage: true,
  isLoading: true,
  remainingItems: 0,
  text: 'Show More',
};

export default ShowMoreButton;
